import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7001Model } from '../kymw7001.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { ReplacementListInfo } from '../vo/replacement-list-info.model';
import { PlessViewUtils } from 'src/app/shared/utils/pless-view-utils.service';

/**
 * 選定依頼登録サービス
 * @export RegistFeatureRequestBuyerService
 * @class RegistFeatureRequestBuyerService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistFeatureRequestBuyerService extends PlessJsonResponderSub<null> {
  model: KYMW7001Model;
  selectItem: ReplacementListInfo;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistFeatureRequestBuyerService
   */
  private getBody(): PlessRequest {
    let planNum = this.selectItem.predictPlanNum;
    if (!PlessViewUtils.isEmpty(this.selectItem.planNum)) {
      planNum = this.selectItem.planNum;
    }

    const pricePatternName = this.model.PricePetternList.filter(
      priceItem => priceItem.CodeName ==  this.selectItem.pricePattern);
    const pricePattern = pricePatternName.length == 1 ? pricePatternName[0].CodeValue : null;

    const registObj = {
      ReplacementList: {
        parameter: {
          OrderCode: this.model.orderCode,
          MediumType: this.model.mediumType,
          RequestBuyer: this.selectItem.requestBuyer,
          FeatureCode: this.selectItem.featureCode,
          ClassCode: this.selectItem.classCode,
          MiddleClassCode: this.selectItem.middleClassCode,
          PCode: this.selectItem.pCode,
          PricePattern: pricePattern,
          ThisTimeSupplyPrice: this.selectItem.thisTimeSupplyPrice,
          PlanNum: planNum,
          PlanSupplyBudget: this.selectItem.planSupplyBudget,
          Remarks: this.selectItem.remarks,
          ItemCode: this.selectItem.itemCode,
        },
      }
    }

    return new PlessRequest({ regist: registObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistFeatureRequestBuyerService
   */
  execute(model: KYMW7001Model, selectItem: ReplacementListInfo, f?: () => void): void {
    this.model = model;
    this.selectItem = selectItem;
    if (f) this.calbak = f;
    this.send('registFeatureRequestBuyer', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof RegistFeatureRequestBuyerService
   */
  success() {
    this.dialogService.openAlertGetMessage('I0508', ['担当者への選定依頼']);
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    this.dialogService.openAlertGetMessage('E0574', ['担当者への選定依頼']);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    this.dialogService.openAlertGetMessage('E0574', ['担当者への選定依頼']);
  }
}
